import type { LeaderboardMetric } from "@expert/app-config/types";

import { useQuery } from "@tanstack/react-query";

import { getCurrentLeaderboard } from "../../../../api/getCurrentLeaderboard";
import { useSalesContext } from "../../../../sales-context/SalesContext";

export const useLeaderboard = (metric: LeaderboardMetric, sku?: string) => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: [`${metric}-leaderboard`],
        queryFn: async () => getCurrentLeaderboard(apiClients.gamification, metric, sku),
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};
